import ResponseTemplate from './ResponseTemplate.js'

/**
 * @class
 * @implements ResponseTemplate
 */
export default class DraftUpdateResponseTemplate extends ResponseTemplate {
  /**
   * @method
   * @return {Array<Object, Object>}
   */

  build() {
    return {
      status: 200
    }
  }
}
